import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { EMAIL_VALIDATION_PATTERN } from "../../../../utils/constants";

const UserEmailAddress = (props) => {
  const { userEmailAddress, isEditDisable } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("email_address")}
          validationMessage={props.errors?.userEmailAddress?.message}
          id="userEmailAddress"
          placeholder={t("enter_email_address")}
          name="userEmailAddress"
          disabled={isEditDisable}
          inputDefaultValue={userEmailAddress}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={
            !isEditDisable
              ? props.register("userEmailAddress", {
                  required: `${t(
                    "validation_message.email_address_is_required"
                  )}`,
                  pattern: {
                    value: EMAIL_VALIDATION_PATTERN,
                    message: t("validation_message.value_does_not_match_email"),
                  },
                })
              : ""
          }
        />
      </Stack>
    </>
  );
};

export default UserEmailAddress;
